<template>
  <div>
    <div class="card-body py-0 px-0">
      <div class="card-header bg-light">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-filter text-success me-2"></i>Filtros de Viajes
          </h5>
          <button
            type="button"
            class="btn bg-navy btn-sm"
            @click="cargarDatos"
            :disabled="cargando"
          >
            <i
              class="fas fa-sync-alt me-1"
              :class="{ 'fa-spin': cargando }"
            ></i>
            Actualizar
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-success"
            @click="mostrarFiltros = !mostrarFiltros"
            :title="mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
          >
            <i
              :class="
                mostrarFiltros ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
              "
            ></i>
            {{ mostrarFiltros ? "Ocultar" : "Mostrar" }}
          </button>
        </div>
      </div>
      <div class="card-body bg-light" v-show="mostrarFiltros">
        <div class="row">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-building text-primary me-1"></i> Empresa
            </label>
            <!-- 25/08/2026 - Se agrega getDarkMode para modo claro/oscuro. Aprobado por Cristian -->
            <v-select
              v-model="filtros.empresa_id"
              :options="listasForms.empresas"
              label="nombre"
              placeholder="Todas las empresas"
              :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
              class="form-control-sm p-0"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-truck text-warning me-1"></i> Vehículo
            </label>
            <!-- 25/08/2026 - Se agrega getDarkMode para modo claro/oscuro. Aprobado por Cristian -->
            <v-select
              v-model="filtros.vehiculo_id"
              :options="listasForms.vehiculos"
              @input="buscarViajes()"
              label="placa"
              placeholder="Todos los vehículos"
              
              :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
              class="form-control-sm p-0"
            ></v-select>
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-route text-info me-1"></i> Número de Viaje
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="filtros.numero_viaje"
              placeholder="ID del viaje"
              @keyup.enter="buscarViajes"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-ticket-alt text-secondary me-1"></i> Ticket
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="filtros.ticket"
              placeholder="Número de ticket"
              @keyup.enter="buscarViajes"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-map-marker-alt text-danger me-1"></i> Origen
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="filtros.origen"
              placeholder="Ciudad de origen"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-flag-checkered text-success me-1"></i> Destino
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="filtros.destino"
              placeholder="Ciudad de destino"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Desde
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_desde"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha Hasta
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_hasta"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha
              Programación Desde
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_programacion_desde"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-calendar text-primary me-1"></i> Fecha
              Programación Hasta
            </label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="filtros.fecha_programacion_hasta"
              :max="fechaMaxima"
            />
          </div>
          <div class="col-md-3 mt-2">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-map-marker-alt text-danger me-1"></i> #
              Programación
            </label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="filtros.zafiro_id"
              placeholder="Programación"
            />
          </div>
          <!-- Filtro nuevo: Estado de viaje (ocupación del espacio vacío junto a Programación) -->
          <!-- 25/08/2026 - Se agrega getDarkMode para modo claro/oscuro. Aprobado por Cristian -->
          <div class="col-md-3 mt-2">
            <label class="form-label small text-muted mb-1">
              <i class="fas fa-traffic-light text-info me-1"></i> Estado de
              viaje
            </label>
            <v-select
              v-model="filtros.estado"
              :options="listasForms.estados"
              label="descripcion"
              :reduce="(estado) => estado.numeracion"
              @input="buscarViajes()"
              multiple
              placeholder="Todos los estados"
              :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
              class="form-control-sm p-0"
            ></v-select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-success btn-sm"
                @click="buscarViajes"
                :disabled="cargando"
              >
                <i class="fas fa-search me-1" v-if="!cargando"></i>
                <i class="fas fa-spinner fa-spin me-1" v-else></i>
                {{ cargando ? "Buscando..." : "Buscar" }}
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                @click="limpiarFiltros"
              >
                <i class="fas fa-eraser me-1"></i> Limpiar Filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de Postulaciones y Viajes -->
    <div class="card shadow">
      <div class="card-header bg-gradient-secondary text-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="fas fa-list me-2"></i> Postulaciones y Viajes Activos
            <span class="badge bg-light text-dark ml-1"
              >{{ totalPostulaciones + totalViajes }} registros</span
            >
          </h5>
          <div class="d-flex gap-2">
            <span class="badge bg-warning text-dark">
              <i class="fas fa-file-alt me-1"></i>
              {{ totalPostulaciones }} Postulaciones
            </span>
            <span class="badge bg-info text-white ml-1">
              <i class="fas fa-truck me-1"></i>
              {{ totalViajes }} Viajes
            </span>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <div v-if="cargando" class="text-center p-4">
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2">Cargando datos...</p>
        </div>
        <div v-else-if="datos.length === 0" class="text-center p-4">
          <i class="fas fa-info-circle fa-3x text-muted mb-3"></i>
          <p class="text-muted">
            No hay postulaciones o viajes activos disponibles
          </p>
        </div>
        <div v-else class="table-responsive">
          <table
            class="table table-striped table-hover mb-0 text-nowrap table-bordered"
          >
            <thead class="table-dark">
              <tr>
                <th>Acciones</th>
                <th>#</th>
                <th class="text-center">Tiempo Estimado <br />Arribo</th>
                <th>Código</th>
                <th># Programación</th>
                <th>N° Guía</th>
                <th>Ticket</th>
                <th>Vehículo</th>
                <th>Remolque</th>
                <th>Conductor</th>
                <th>Empresa</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Despachado A</th>
                <th>Producto</th>
                <th>Producto Líquido</th>
                <th>Tipo Punto</th>
                <th>Ultimo Punto</th>
                <th>Estado</th>
                <th>Fechas Cargue</th>
                <th>Fechas Descargue</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in datos"
                :key="index"
                class="text-center"
              >
                <td class="text-center">
                  <div
                    class="btn-group"
                    :class="datos.length == 1 ? 'dropop' : 'dropright'"
                    style="position: static; z-index: auth"
                  >
                    <button
                      type="button"
                      class="btn btn-dark btn-sm"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-align-justify"></i>
                    </button>
                    <div class="dropdown-menu" style="z-index: 10000">
                      <!-- Crear Número Programación -->
                      <a
                        v-if="
                          !item.zafiro_id &&
                          $store.getters.can(
                            'admin.centralTrafico.asignarNumeroProgramacion'
                          )
                        "
                        class="dropdown-item"
                        style="cursor: pointer"
                        @click="crearNumeroZafiro(item)"
                        :title="`Crear número programación para el viaje ${item.id}`"
                      >
                        <i class="fas fa-hashtag"></i>
                        Crear Número Programación
                      </a>
                      <!-- Cambiar Ruta -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-trinomios"
                        style="cursor: pointer"
                        @click="llenarModalEntidad(item, 'Ruta')"
                        v-if="
                          $store.getters.can('admin.centralTrafico.cambiarRuta')
                        "
                        :title="`Cambiar ruta para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-exchange-alt"></i>
                        Cambiar Ruta
                      </a>
                      <!-- Cambiar Vehiculo -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-trinomios"
                        style="cursor: pointer"
                        v-if="
                          $store.getters.can(
                            'admin.centralTrafico.cambiarVehiculo'
                          )
                        "
                        @click="llenarModalEntidad(item, 'Vehiculo')"
                        :title="`Cambiar vehiculo para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-car"></i>
                        Cambiar Vehiculo
                      </a>
                      <!-- Cambiar Remolque -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-trinomios"
                        style="cursor: pointer"
                        v-if="
                          $store.getters.can(
                            'admin.centralTrafico.cambiarRemolque'
                          )
                        "
                        @click="llenarModalEntidad(item, 'Remolque')"
                        :title="`Cambiar remolque para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-truck"></i>
                        Cambiar Remolque
                      </a>
                      <!-- Cambiar Conductor -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-trinomios"
                        style="cursor: pointer"
                        v-if="
                          $store.getters.can(
                            'admin.centralTrafico.cambiarConductor'
                          )
                        "
                        @click="llenarModalEntidad(item, 'Conductor')"
                        :title="`Cambiar conductor para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-user-alt"></i>
                        Cambiar Conductor
                      </a>
                      <!-- Inspeccion -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-inspeccion"
                        style="cursor: pointer"
                        v-if="
                          buscarProcesos(item.procesos, 1) &&
                          $store.getters.can(
                            'admin.centralTrafico.inspeccionar'
                          )
                        "
                        :title="`Inspeccionar ${
                          item.tipo == 'Viaje' ? 'Viaje' : 'Solicitud Diaria'
                        }`"
                        @click="llenarModalInspeccion(item, item.tipo)"
                      >
                        <i class="fas fa-binoculars"></i>
                        Inspección
                      </a>
                      <!-- Marcar LLegada -->
                      <a
                        class="dropdown-item"
                        style="cursor: pointer"
                        data-toggle="modal"
                        data-target="#modal-form-marcar-llegada"
                        @click="llenarModalLlegada(item.id, item.ruta_id)"
                        v-if="
                          $store.getters.can(
                            'admin.centralTrafico.marcarLlegada'
                          ) &&
                          item.ruta_id &&
                          item.tipo == 'Viaje' &&
                          [6, 9].includes(item.estado)
                        "
                        :title="`Marcar llegada para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-people-carry"></i>
                        Marcar llegada
                      </a>
                      <!-- Liberar Vehiculo -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-estado"
                        style="cursor: pointer"
                        v-if="
                          $store.getters.can(
                            'admin.centralTrafico.liberarVehiculo'
                          )
                        "
                        @click="llenarModalDatos(item, 'Liberar Vehiculo', 1)"
                        :title="`Liberar vehiculo para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-unlock"></i>
                        Liberar Vehiculo
                      </a>
                      <!-- Finalizar Vehiculo -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-cambio-estado"
                        style="cursor: pointer"
                        @click="llenarModalDatos(item, 'Finalizar Vehiculo', 2)"
                        v-if="
                          item.tipo == 'Viaje' &&
                          $store.getters.can(
                            'admin.centralTrafico.finalizarVehiculo'
                          )
                        "
                        :title="`Finalizar vehiculo para el ${item.codigo_referencia}`"
                      >
                        <i class="fas fa-check-circle"></i>
                        Finalizar Vehiculo
                      </a>
                      <!-- Crear Viaje -->
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#modal-form-crear-viaje"
                        style="cursor: pointer"
                        @click="abrirModalCrearViaje(item)"
                        v-if="item.tipo == 'Postulacion'"
                        :title="`Crear viaje para la postulación ${item.id}`"
                      >
                        <i class="fas fa-route"></i>
                        Crear Viaje
                      </a>
                    </div>
                  </div>
                </td>
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">
                  <div
                    v-if="
                      item.tiempo_estimado_llegada &&
                      (item.estado === 6 || item.estado === 9)
                    "
                    class="d-flex flex-column align-items-center"
                  >
                    <span
                      class="badge"
                      :class="
                        getTiempoEstimadoColor(item.tiempo_estimado_llegada)
                      "
                      :title="`Fecha y hora estimada de llegada al ${
                        item.estado === 6
                          ? 'sitio de cargue'
                          : 'sitio de descargue'
                      }`"
                    >
                      <i class="fas fa-clock me-1"></i>
                      {{
                        formatearFechaHoraEstimada(item.tiempo_estimado_llegada)
                      }}
                    </span>
                    <small class="text-muted mt-1" style="font-size: 0.7rem">
                      {{ tiempoRestante(item.tiempo_estimado_llegada) }}
                    </small>
                  </div>
                  <span v-else class="text-muted">-</span>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="badge bg-secondary text-white"
                    data-toggle="modal"
                    data-target="#modal-form-detViaje"
                    @click="
                      $refs.gestionHidrocarburosDet.getDatosEntidad(
                        item.id,
                        item.tipo,
                        1
                      )
                    "
                  >
                    {{ item.codigo_referencia }}
                  </button>
                </td>
                <td class="text-center">
                  <span class="badge bg-navy" v-if="item.zafiro_id">
                    {{ item.zafiro_id }}
                  </span>
                  <span class="text-muted" v-else> Sin programación </span>
                </td>
                <td class="text-center">
                  <div class="d-flex flex-column align-items-center">
                    <div class="fw-semibold">
                      <span v-if="item.numero_guia">
                        {{ item.numero_guia }}
                      </span>
                      <span class="text-muted" v-else> Sin guía </span>
                    </div>
                    <!-- Barra de vigencia -->
                    <div
                      v-if="item.numero_guia"
                      class="barra-vigencia mt-1"
                      :class="
                        colorVigencia(
                          item.guia_fecha_expedicion,
                          item.vigencia_guia
                        )
                      "
                      :title="`Vigencia: ${item.vigencia_guia}h, Expedición: ${item.guia_fecha_expedicion}`"
                    ></div>
                  </div>
                </td>
                <td class="text-center">
                  <span v-if="item.numero_ticket">
                    {{ item.numero_ticket }}
                  </span>
                  <span class="text-muted" v-else> Sin ticket </span>
                </td>
                <td class="text-center">
                  <div class="d-flex flex-column align-items-center">
                    <div class="d-flex align-items-center">
                      <span class="fw-semibold">{{
                        item.vehiculo_placa || "N/A"
                      }}</span>
                      <i
                        v-if="item.vehiculo_fecha_ultimo_gps"
                        :class="[
                          'ml-1 fas',
                          gpsDentroDe2Horas(item.vehiculo_fecha_ultimo_gps)
                            ? 'fa-check-circle text-success'
                            : 'fa-times-circle text-danger',
                        ]"
                        :title="`Último GPS: ${formatFecha(
                          item.vehiculo_fecha_ultimo_gps
                        )}`"
                      ></i>
                      <i
                        v-else
                        class="fas fa-minus-circle text-muted"
                        title="Sin GPS"
                      ></i>
                    </div>
                    <small
                      class="text-muted"
                      v-if="item.vehiculo_tipo_propiedad"
                      >{{ item.vehiculo_tipo_propiedad }}</small
                    >
                  </div>
                </td>
                <td class="text-center">
                  <span v-if="item.remolque_placa">
                    {{ item.remolque_placa }}
                  </span>
                  <span class="text-muted" v-else> Sin remolque </span>
                </td>
                <td class="text-center">
                  <div v-if="item.conductor_nombres">
                    <div>
                      {{ item.conductor_nombres }}
                      {{ item.conductor_apellidos }}
                    </div>
                    <small class="text-muted">{{
                      item.conductor_documento
                    }}</small>
                  </div>
                  <span v-else class="text-muted">N/A</span>
                </td>
                <td class="text-center">
                  {{ item.empresa || "N/A" }}
                </td>
                <td class="text-center">
                  {{ item.sitio_origen || "Sin origen" }}
                </td>
                <td class="text-center">
                  {{ item.sitio_destino || "Sin destino" }}
                </td>
                <td class="text-center">
                  <span v-if="item.despachado_a">
                    {{ item.despachado_a }}
                  </span>
                  <span class="text-muted" v-else> Sin despachado a </span>
                </td>
                <td class="text-center">
                  {{ item.producto || "Sin producto" }}
                </td>
                <td class="text-center">
                  <span v-if="item.producto_liquido">
                    {{ item.producto_liquido }}
                  </span>
                  <span class="text-muted" v-else> Sin producto líquido </span>
                </td>
                <td class="text-center">
                  <span v-if="item.sitio_type">
                    {{
                      item.sitio_type == "App\\Sitio"
                        ? "Sitio"
                        : "Punto Gestión"
                    }}
                  </span>
                  <span class="text-muted" v-else> Sin tipo de punto </span>
                </td>
                <td class="text-center">
                  <span v-if="item.ultPunto">
                    {{ item.ultPunto }}
                  </span>
                  <span class="text-muted" v-else> Sin punto </span>
                </td>
                <td class="text-center">
                  <span class="badge" :class="getEstadoColor(item.estado)">
                    {{ item.estado_nombre || item.estado }}
                  </span>
                </td>
                <td class="text-center">
                  <div
                    class="fechas-container"
                    style="font-size: 0.7rem; line-height: 1.2"
                  >
                    <div class="text-left">
                      <div>
                        <strong>Cita:</strong>
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.cita_cargue || "Sin cita de cargue" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        E - Llegada:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_llegada_enturne_cargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        E - Salida:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_salida_enturne_cargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        S - Llegada:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_llegada_cargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        S - Salida:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_salida_cargue || "N/A" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="fechas-container"
                    style="font-size: 0.7rem; line-height: 1.2"
                  >
                    <div class="text-left">
                      <div style="margin-left: 8px" class="mt-2 pt-1">
                        E - Llegada:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_llegada_enturne_descargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        E - Salida:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_salida_enturne_descargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        S - Llegada:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_llegada_descargue || "N/A" }}
                        </span>
                      </div>
                      <div style="margin-left: 8px">
                        S - Salida:
                        <span class="badge bg-light border border-default ml-1">
                          {{ item.fecha_salida_descargue || "N/A" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <GestionHidrocarburosDet ref="gestionHidrocarburosDet" />
    <GestionHidrocarburosEstado ref="gestionHidrocarburosEstado" />
    <GestionHidrocarburosCambios ref="gestionHidrocarburosCambios" />
    <GestionInspeccionHidrocarburos ref="gestionInspeccionHidrocarburos" />
    <GestionHidrocarburosMarcarLlegada
      ref="gestionHidrocarburosMarcarLlegada"
    />
    <GestionHidrocarburosCrearViaje ref="gestionHidrocarburosCrearViaje" />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import GestionHidrocarburosDet from "./GestionHidrocarburosDet.vue";
import GestionHidrocarburosEstado from "./GestionHidrocarburosEstado.vue";
import GestionHidrocarburosCambios from "./GestionHidrocarburosCambios.vue";
import GestionInspeccionHidrocarburos from "./GestionInspeccionHidrocarburos.vue";
import GestionHidrocarburosMarcarLlegada from "./GestionHidrocarburosMarcarLlegada.vue";
import GestionHidrocarburosCrearViaje from "./GestionHidrocarburosCrearViaje.vue";

export default {
  name: "GestionHidrocarburos",
  components: {
    vSelect,
    GestionHidrocarburosDet,
    GestionHidrocarburosEstado,
    GestionHidrocarburosCambios,
    GestionInspeccionHidrocarburos,
    GestionHidrocarburosMarcarLlegada,
    GestionHidrocarburosCrearViaje,
  },
  data() {
    return {
      cargando: false,
      datos: [],
      totalPostulaciones: 0,
      totalViajes: 0,
      filtros: {
        empresa_id: null,
        vehiculo_id: null,
        numero_viaje: null,
        ticket: null,
        origen: null,
        destino: null,
        fecha_desde: null,
        fecha_hasta: null,
        fecha_programacion_desde: null,
        fecha_programacion_hasta: null,
        zafiro_id: null,
        estado: [], // Se agrega filtro por estado de viaje (múltiple) 25/08/2026
      },
      listasForms: {
        empresas: [],
        vehiculos: [],
        estados: [], // Se agrega lista de estados de viaje (lista 39) 25/08/2026
      },
      mostrarFiltros: true,
      ultimaActualizacion: moment().format("DD/MM/YYYY HH:mm:ss"),
      relojEta: Date.now(),
      intervaloDatos: null,
      intervaloRelojEta: null,
    };
  },
  computed: {
    fechaMaxima() {
      return moment().format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.cargarListas();
    this.cargarDatos();
    this.iniciarActualizacionAutomatica();
  },
  beforeDestroy() {
    this.detenerActualizacionAutomatica();
  },
  methods: {
    gpsDentroDe2Horas(fecha) {
      if (!fecha) return false;
      const haceDosHoras = moment().subtract(2, "hours");
      return moment(fecha).isAfter(haceDosHoras);
    },

    colorVigencia(fechaExpedicion, horasVigencia) {
      const inicio = moment(fechaExpedicion);
      const vencimiento = moment(fechaExpedicion).add(
        Number(horasVigencia),
        "hours"
      );
      const ahora = moment();

      if (!inicio.isValid() || !vencimiento.isValid()) {
        return "";
      }

      if (ahora.isAfter(vencimiento)) {
        return "barra-roja";
      }

      const umbralAmarillo = moment(vencimiento).subtract(2, "hours");
      const esAmarillo = ahora.isAfter(umbralAmarillo);

      return esAmarillo ? "barra-amarilla" : "barra-verde";
    },

    async cargarListas() {
      try {
        const [empresasResponse, vehiculosResponse, estadosResponse] =
          await Promise.all([
            axios.get("/api/admin/centralTrafico/empresas"),
            axios.get("/api/admin/centralTrafico/vehiculos"),
            axios.get("/api/lista/39"), // Se agrega carga de estados de viaje
          ]);

        this.listasForms.empresas = empresasResponse.data.map((empresa) => ({
          id: empresa.id,
          nombre: empresa.nombre,
        }));

        this.listasForms.vehiculos = vehiculosResponse.data.map((vehiculo) => ({
          id: vehiculo.id,
          placa: vehiculo.nombre,
        }));

        // Se agrega asignación de estados para el selector del filtro 25/08/2026
        this.listasForms.estados = estadosResponse.data;
      } catch (error) {
        console.error("Error al cargar vehículos:", error);
      }
    },

    iniciarActualizacionAutomatica() {
      this.intervaloDatos = setInterval(() => {
        this.cargarDatos(true);
      }, 60000);

      this.intervaloRelojEta = setInterval(() => {
        this.relojEta = Date.now();
      }, 30000);
    },

    detenerActualizacionAutomatica() {
      if (this.intervaloDatos) {
        clearInterval(this.intervaloDatos);
        this.intervaloDatos = null;
      }
      if (this.intervaloRelojEta) {
        clearInterval(this.intervaloRelojEta);
        this.intervaloRelojEta = null;
      }
    },

    async cargarDatos(silencioso = false) {
      if (!silencioso) {
        this.cargando = true;
      }
      try {
        const params = {
          empresa_id: this.filtros.empresa_id?.id || this.filtros.empresa_id,
          vehiculo_id: this.filtros.vehiculo_id?.id || this.filtros.vehiculo_id,
          numero_viaje: this.filtros.numero_viaje,
          ticket: this.filtros.ticket,
          origen: this.filtros.origen,
          destino: this.filtros.destino,
          fecha_desde: this.filtros.fecha_desde,
          fecha_hasta: this.filtros.fecha_hasta,
          fecha_programacion_desde: this.filtros.fecha_programacion_desde,
          fecha_programacion_hasta: this.filtros.fecha_programacion_hasta,
          zafiro_id: this.filtros.zafiro_id,
          estado: this.obtenerEstadosFiltro(),
        };

        const response = await axios.get(
          "/api/admin/centralTrafico/postulacionesViajesActivos",
          {
            params,
            paramsSerializer: (queryParams) => {
              const search = new URLSearchParams();
              Object.keys(queryParams).forEach((key) => {
                const value = queryParams[key];
                if (value === null || value === undefined || value === "") {
                  return;
                }
                if (Array.isArray(value)) {
                  value.forEach((item) => {
                    search.append(`${key}[]`, item);
                  });
                  return;
                }
                search.append(key, value);
              });
              return search.toString();
            },
          }
        );

        this.datos = response.data.data;
        this.totalPostulaciones = response.data.total_postulaciones;
        this.totalViajes = response.data.total_viajes;

        this.ultimaActualizacion = moment().format("DD/MM/YYYY HH:mm:ss");
        this.relojEta = Date.now();
      } catch (error) {
        if (!silencioso) {
          this.$swal({
            icon: "error",
            title: "Error",
            text:
              "Error al cargar los datos: " +
              (error.response?.data?.message || error.message),
          });
        }
      } finally {
        if (!silencioso) {
          this.cargando = false;
        }
      } 
    },

    obtenerEstadosFiltro() {
      const estado = this.filtros.estado;
      if (!estado || (Array.isArray(estado) && estado.length === 0)) {
        return [];
      }

      const seleccion = Array.isArray(estado) ? estado : [estado];
      return seleccion
        .map((item) => item?.numeracion ?? item)
        .filter((item) => item !== null && item !== undefined && item !== "")
        .map((item) => Number(item));
    },

    buscarViajes() {
      this.cargarDatos();
    },

    limpiarFiltros() {
      this.filtros = {
        empresa_id: null,
        vehiculo_id: null,
        numero_viaje: null,
        ticket: null,
        origen: null,
        destino: null,
        fecha_desde: null,
        fecha_hasta: null,
        estado: [], // Se agrega limpieza del filtro de estado de viaje
      };
      this.cargarDatos();
    },

    getEstadoColor(estado) {
      const colores = {
        1: "bg-primary", // En punto de gestión
        2: "bg-info", // En ruta
        3: "bg-warning", // En destino
        4: "bg-success", // Completado
        5: "bg-secondary", // Cancelado
        6: "bg-danger", // Retrasado
        7: "bg-dark", // Pausado
        9: "bg-primary", // En carga
        10: "bg-info", // En descarga
        15: "bg-warning", // En espera
      };
      return colores[estado] || "bg-secondary";
    },

    formatearFechaHoraEstimada(fechaHoraEstimada) {
      if (!fechaHoraEstimada) return "-";

      try {
        const fecha = moment(fechaHoraEstimada);
        // Mostrar siempre fecha y hora: DD/MM/YYYY HH:mm
        return fecha.format("DD/MM/YYYY HH:mm");
      } catch (error) {
        return fechaHoraEstimada;
      }
    },

    tiempoRestante(fechaHoraEstimada) {
      if (!fechaHoraEstimada) return "";

      try {
        void this.relojEta;
        const fecha = moment(fechaHoraEstimada);
        const ahora = moment();
        const diff = fecha.diff(ahora, "minutes");

        if (diff < 0) {
          return "Tiempo vencido";
        }

        if (diff < 60) {
          return `En ${diff} min`;
        }

        const horas = Math.floor(diff / 60);
        const minutos = diff % 60;

        if (minutos > 0) {
          return `En ${horas}h ${minutos}min`;
        }
        return `En ${horas}h`;
      } catch (error) {
        return "";
      }
    },

    getTiempoEstimadoColor(fechaHoraEstimada) {
      if (!fechaHoraEstimada) return "bg-secondary";

      try {
        const fecha = moment(fechaHoraEstimada);
        const ahora = moment();
        const diffMinutos = fecha.diff(ahora, "minutes");

        // Si ya pasó la hora estimada
        if (diffMinutos < 0) {
          return "bg-danger text-white";
        }

        // Verde si es menos de 30 minutos
        if (diffMinutos < 30) {
          return "bg-success text-white";
        }
        // Amarillo si es entre 30 minutos y 1 hora
        if (diffMinutos < 60) {
          return "bg-warning text-dark";
        }
        // Naranja si es entre 1 y 2 horas
        if (diffMinutos < 120) {
          return "bg-warning text-dark";
        }
        // Rojo si es más de 2 horas
        return "bg-danger text-white";
      } catch (error) {
        return "bg-secondary";
      }
    },

    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },

    verFechas(item) {
      const esPostulacion = item.tipo === "Postulación";
      const titulo = esPostulacion
        ? `Fechas de la Postulación ${item.id}`
        : `Fechas del Viaje ${item.id}`;

      let fechasHtml = "";

      if (esPostulacion) {
        fechasHtml = `
          <div class="text-left">
            <p><strong>Fecha Cita:</strong> ${item.fecha_cita || "N/A"}</p>
            <p><strong>Hora Cita:</strong> ${item.hora_cita || "N/A"}</p>
            <p><strong>Fecha Creación:</strong> ${this.formatFecha(
              item.created_at
            )}</p>
            <p><strong>Fecha Actualización:</strong> ${this.formatFecha(
              item.updated_at
            )}</p>
          </div>
        `;
      } else {
        fechasHtml = `
          <div class="text-left">
            <h6 class="text-primary mb-3"><i class="fas fa-calendar-check me-2"></i>Fechas del Viaje</h6>

            <div class="row">
              <div class="col-md-6">
                <h6 class="text-info mb-2">📅 Fecha de Cita</h6>
                <p><strong>Cita Cargue:</strong> ${
                  item.cita_cargue || "N/A"
                }</p>

                <h6 class="text-info mb-2">🚛 Enturne Cargue</h6>
                <p><strong>Fecha Llegada:</strong> ${
                  item.fecha_enturne_cargue || "N/A"
                }</p>
                <p><strong>Fecha Salida:</strong> ${
                  item.fecha_enturne_cargue_propuesto || "N/A"
                }</p>

                <h6 class="text-info mb-2">🏭 Sitio de Cargue</h6>
                <p><strong>Fecha Llegada:</strong> ${
                  item.fecha_hora_inicio_cargue || "N/A"
                }</p>
                <p><strong>Fecha Salida:</strong> ${
                  item.fecha_cargue || "N/A"
                }</p>
              </div>

              <div class="col-md-6">
                <h6 class="text-info mb-2">🚛 Enturne Descargue</h6>
                <p><strong>Fecha Llegada:</strong> ${
                  item.fecha_enturne_descargue || "N/A"
                }</p>
                <p><strong>Fecha Salida:</strong> ${
                  item.fecha_enturne_descargue_propuesto || "N/A"
                }</p>

                <h6 class="text-info mb-2">🏭 Sitio de Descargue</h6>
                <p><strong>Fecha Llegada:</strong> ${
                  item.fecha_descargue || "N/A"
                }</p>
                <p><strong>Fecha Salida:</strong> ${
                  item.fecha_fin_viaje || "N/A"
                }</p>

                <h6 class="text-info mb-2">📋 Otras Fechas</h6>
                <p><strong>Fecha Solicitud:</strong> ${
                  item.fecha_solicitud || "N/A"
                }</p>
                <p><strong>Fecha Creación Viaje:</strong> ${
                  item.fecha_creacion_viaje || "N/A"
                }</p>
                <p><strong>Fecha Expedición Guía:</strong> ${
                  item.guia_fecha_expedicion || "N/A"
                }</p>
              </div>
            </div>
          </div>
        `;
      }

      this.$swal({
        icon: "info",
        title: titulo,
        html: fechasHtml,
        confirmButtonText: "Cerrar",
      });
    },

    //Dropdown actions
    crearNumeroZafiro(data) {
      this.$swal({
        title:
          "Crear número programación para el tipo " + data.codigo_referencia,
        html: `
          <div style="text-align: left; margin-bottom: 20px;">
            <p><strong>Conductor:</strong> ${data.conductor_apellidos}</p>
            <p><strong>Vehículo:</strong> ${data.vehiculo_placa}</p>
            <p><strong>Remolque:</strong> ${
              data.remolque_placa || "No presenta remolque"
            }</p>
            <p><strong>Transportadora:</strong> ${data.empresa}</p>
          </div>
          <div style="margin-top: 20px;">
            <label for="numeroZafiro" style="display: block; margin-bottom: 8px; font-weight: bold;">Número Programación:</label>
            <input
              type="number"
              id="numeroZafiro"
              class="swal2-input"
              placeholder="Ingrese el número programación"
              min="1"
              required
              style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px;"
            />
          </div>
        `,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Crear Número Programación",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          // Esperar un poco para que SweetAlert2 termine de renderizar
          setTimeout(() => {
            const input = document.getElementById("numeroZafiro");
            const confirmButton = document.querySelector(".swal2-confirm");

            if (input && confirmButton) {
              // Ocultar el botón inicialmente
              confirmButton.style.visibility = "hidden";
              confirmButton.style.opacity = "0";
              confirmButton.disabled = true;

              // Función para verificar el input
              const checkInput = () => {
                const value = input.value.trim();
                if (value && parseInt(value) > 0) {
                  confirmButton.style.visibility = "visible";
                  confirmButton.style.opacity = "1";
                  confirmButton.disabled = false;
                } else {
                  confirmButton.style.visibility = "hidden";
                  confirmButton.style.opacity = "0";
                  confirmButton.disabled = true;
                }
              };

              // Verificar en tiempo real
              input.addEventListener("input", checkInput);
              input.addEventListener("keyup", checkInput);
              input.addEventListener("paste", () => {
                setTimeout(checkInput, 10);
              });
            }
          }, 200);
        },
        preConfirm: () => {
          const numeroZafiro = document.getElementById("numeroZafiro").value;

          if (!numeroZafiro || numeroZafiro.trim() === "") {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "Por favor ingrese un número programación válido",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          if (parseInt(numeroZafiro) <= 0) {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "El número programación debe ser mayor a 0",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          return numeroZafiro;
        },
      }).then((result) => {
        if (result.value) {
          const numeroZafiro = result.value;

          // Confirmación final
          this.$swal({
            title: "¿Confirmar creación?",
            text: `¿Está seguro de crear el número programación "${numeroZafiro}" para este ${data.codigo_referencia}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Crear!",
            cancelButtonText: "Cancelar",
          }).then((confirmResult) => {
            if (confirmResult.value) {
              // Aquí puedes enviar los datos al backend
              this.enviarNumeroZafiro(data, numeroZafiro);
            }
          });
        }
      });
    },

    enviarNumeroZafiro(data, numeroZafiro) {
      this.cargando = true;
      axios
        .put("/api/admin/centralTrafico/saveNumberProgramacion", {
          entidad_id: data.id,
          tipo: data.codigo_referencia,
          numero_programacion: numeroZafiro,
        })
        .then((response) => {
          this.$swal({
            title: "¡Éxito!",
            text: "Número programación creado correctamente",
            icon: "success",
          });
          this.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "No se pudo crear el número zafiro",
            icon: "error",
          });
          this.cargando = false;
        });
    },

    llenarModalEntidad(data, entidad) {
      let dataForm = {};
      dataForm = {
        tipo_entidad_type: data.tipo,
        tipo_entidad_id: data.id,
        vehiculo_id: data.vehiculo_id,
        tipo_vehiculo_id: data.tipo_vehiculo_id,
        vehiculo_placa: data.vehiculo_placa,
        remolque_id: data.remolque_id,
        remolque_placa: data.remolque_placa,
        conductor_id: data.conductor_id,
        conductor_documento: data.conductor_documento,
        conductor_nombre:
          data.conductor_nombres + " " + data.conductor_apellidos,
        ruta_id: data.ruta_id,
        ruta_nombre: data.ruta_nombre,
        empresa_id: data.empresa_id,
        sitio_cargue_id: data.sitio_cargue_id,
        estado_entidad: data.estado_nombre,
      };
      this.$refs.gestionHidrocarburosCambios.getIndex(dataForm, entidad);
    },

    llenarModalDatos(data, opcionModal, tipo) {
      this.$refs.gestionHidrocarburosEstado.llenarModal(
        data,
        opcionModal,
        tipo
      );
    },

    buscarProcesos(procesos, opcion) {
      if (!procesos) return false;
      let procesosSp = procesos.split(",").map((item) => item.trim());
      for (let i = 0; i < procesosSp.length; i++) {
        switch (procesosSp[i]) {
          case "69":
            return opcion == 1 ? true : false; // Proceso para inspección
          case "70":
            return opcion == 2 ? true : false; // Proceso para enturne
          case "71":
            return opcion == 3 ? true : false; // Proceso para imprimir guia
          case "612":
            return opcion == 4 ? true : false; // Proceso para imprimir ticket
          case "4237":
            return opcion == 5 ? true : false; // Proceso para validar inspección
        }
      }
      return false; // Retorna false si no encuentra el proceso buscado
    },

    llenarModalInspeccion(viaje, tipo) {
      this.$refs.gestionInspeccionHidrocarburos.llenarModalInspeccion(
        viaje,
        tipo
      );
    },

    llenarModalLlegada(viaje, ruta_id) {
      this.$refs.gestionHidrocarburosMarcarLlegada.llenarModal(viaje, ruta_id);
    },

    abrirModalCrearViaje(item) {
      this.$refs.gestionHidrocarburosCrearViaje.llenarModal(
        item.id,
        item.sitio_id,
        item.sitio_destino_id
      );
    },
  },
};
</script>
